import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import { userApi } from "api/userApi";

/**
 * userPromotionAtom에 accessToken은 있지만 nickname 등의 정보가 없을 때
 * userApi.getSimple()을 호출하여 전체 user 정보를 가져오는 훅
 */
export default function useFetchUserPromotion() {
  const [isFetching, setIsFetching] = useState(false);
  const [user, setUser] = useRecoilState(userSimpleAtom);

  useEffect(() => {
    // accessToken은 있지만 nickname이 없으면 user 정보 가져오기
    if (user?.accessToken && !user?.nickname && !isFetching) {
      setIsFetching(true);

      const fetchUser = async () => {
        try {
          const response = await userApi.getSimplePromotion();

          if (response.code === 0 && response.result) {
            setUser((prev) => ({
              ...prev,
              ...response.result,
            }));
          }
        } catch (error) {
          console.error("Failed to fetch user info:", error);
        } finally {
          setIsFetching(false);
        }
      };

      fetchUser();
    }
  }, [user?.accessToken, user?.nickname, isFetching, setUser]);

  return { isFetching };
}
